<template>

  <div :class="isHome ? 'head-container home' : 'head-container'">
    <img :src="require('@/assets/logo.png')" width="72" height="32">
    <span>{{t('site_title')}}</span>

    <cLanguage class="ml-auto"></cLanguage>

    <span class="logout" @click="goLogout()" v-if="logout">
      <img :src="require('@/assets/ico-logout.svg')" width="20" height="20"> {{t('logout')}}
    </span>
    <!-- <div class="top-icon mr-2">
    <img :src="require('@/assets/icon-bell.png')" width="14" height="14">
  </div>
  <div class="top-icon">
    <img :src="require('@/assets/icon-person.png')" width="14" height="14">
  </div> -->
  </div>

</template>

<script setup>
import { computed } from 'vue'
import { useBaseStore } from '@/stores/base'
import { usePopupStore } from '@/stores/popup'
import cLanguage from './cLanguage.vue';
import { strUtil } from '@/utils';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();
const baseStore = useBaseStore()
const popupStore = usePopupStore()
const route = useRoute()

const goLogout = async () => {
  const islogout = await popupStore.openConfirmDialog({ title: t('logout_confirm'), msg: t('logout_msg'), confirmbtn: t('confirm'), cancelbtn: t('cancel2') })
  if (islogout) {
    baseStore.goLogout()
  }
  return false
}
const isHome = computed(() => {
  return route.name === 'home'
})

const logout = computed(() => {
  if (!strUtil.isEmpty(baseStore.managerCd)) {
    return true
  }
  return false
})

</script>

<style lang="scss" scoped>
@import '@/sass/app.scss';

.head-container {
  display: flex;
  position: relative;
  border-bottom: solid 1px #eee;
  box-sizing: border-box;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 40px;
  text-align: left;
  font-size: 14px;
  color: #000;
  background-color: #fff;

  img {
    margin-right: 12px;
  }

  span {
    font-size: 16px;
    letter-spacing: -1.2px;
    line-height: 20px;
    font-family: 'Pretendard GOV';
    color: #111;
    font-weight: bold;
  }
}

.home {
  background-color: #F9F8F5;
}


.top-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
}

.logout {
  display: flex;
  align-items: center;
  border-radius: 24px;
  background-color: #f7f7f7;
  width: auto;
  height: 40px;
  padding: 12px 20px;
  box-sizing: border-box;
  font-size: 16px;
  color: #000;
  font-family: 'Pretendard GOV';
  margin-left: 14px;
  img{
    width: 22px;
    height: 22px;
    margin-right: 3px;
  }
}
</style>
